import {
  ArrowDown,
  ArrowDownAZ,
  ArrowLeft,
  ArrowLeftRight,
  ArrowRight,
  ArrowUp,
  ArrowUpDown,
  BadgeDollarSign,
  Banknote,
  Bell,
  Briefcase,
  Building2,
  Calendar,
  ChartBar,
  ChartColumn,
  ChartLine,
  ChartPie,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  SlidersHorizontal,
  ChevronsDown,
  ChevronsLeft,
  ChevronsRight,
  ChevronsUp,
  CircleAlert,
  CircleCheck,
  CircleChevronDown,
  CircleChevronLeft,
  CircleChevronRight,
  CircleChevronUp,
  CircleDollarSign,
  CircleDot,
  CircleQuestionMark,
  CircleX,
  ClipboardList,
  Clock,
  CloudDownload,
  CloudUpload,
  Coins,
  ConciergeBell,
  Copy,
  CreditCard,
  DollarSign,
  Download,
  Ellipsis,
  ExternalLink,
  Eye,
  EyeOff,
  FileCode,
  FileSpreadsheet,
  FileText,
  Flag,
  Frown,
  HandCoins,
  History,
  Hourglass,
  GripVertical,
  Image,
  Inbox,
  Info,
  Key,
  Landmark,
  Laptop,
  LaptopMinimal,
  LayoutDashboard,
  LayoutGrid,
  Lock,
  LockOpen,
  Link,
  List,
  ListOrdered,
  ListPlus,
  LoaderCircle,
  LogIn,
  LogOut,
  Meh,
  Menu,
  Mic,
  MicOff,
  Minus,
  Monitor,
  Move,
  Network,
  NotebookPen,
  Package,
  Pencil,
  Percent,
  Phone,
  PhoneCall,
  Plus,
  Printer,
  PrinterCheck,
  QrCode,
  Receipt,
  ReceiptText,
  RefreshCw,
  RotateCcw,
  Search,
  Settings,
  Settings2,
  ShieldCheck,
  Smartphone,
  Smile,
  Sparkles,
  SquarePen,
  StickyNote,
  Tablet,
  TabletSmartphone,
  Tag,
  ThumbsDown,
  ThumbsUp,
  Ticket,
  Trash2,
  TriangleAlert,
  Upload,
  User,
  Users,
  Utensils,
  Volume1,
  Volume2,
  VolumeX,
  Wallet,
  Moon,
  Sun,
  Wifi,
  Wrench,
  X
} from 'lucide-angular';

export const APP_ICONS = {
  ArrowDown,
  ArrowDownAZ,
  ArrowLeft,
  ArrowLeftRight,
  ArrowRight,
  ArrowUp,
  ArrowUpDown,
  BadgeDollarSign,
  Banknote,
  Bell,
  Briefcase,
  Building2,
  Calendar,
  ChartBar,
  ChartColumn,
  ChartLine,
  ChartPie,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  SlidersHorizontal,
  ChevronsDown,
  ChevronsLeft,
  ChevronsRight,
  ChevronsUp,
  CircleAlert,
  CircleCheck,
  CircleChevronDown,
  CircleChevronLeft,
  CircleChevronRight,
  CircleChevronUp,
  CircleDollarSign,
  CircleDot,
  CircleQuestionMark,
  CircleX,
  ClipboardList,
  Clock,
  CloudDownload,
  CloudUpload,
  Coins,
  ConciergeBell,
  Copy,
  CreditCard,
  DollarSign,
  Download,
  Ellipsis,
  ExternalLink,
  Eye,
  EyeOff,
  FileCode,
  FileSpreadsheet,
  FileText,
  Flag,
  Frown,
  HandCoins,
  History,
  Hourglass,
  GripVertical,
  Image,
  Inbox,
  Info,
  Key,
  Landmark,
  Laptop,
  LaptopMinimal,
  LayoutDashboard,
  LayoutGrid,
  Lock,
  LockOpen,
  Link,
  List,
  ListOrdered,
  ListPlus,
  LoaderCircle,
  LogIn,
  LogOut,
  Meh,
  Menu,
  Mic,
  MicOff,
  Minus,
  Monitor,
  Move,
  Network,
  NotebookPen,
  Package,
  Pencil,
  Percent,
  Phone,
  PhoneCall,
  Plus,
  Printer,
  PrinterCheck,
  QrCode,
  Receipt,
  ReceiptText,
  RefreshCw,
  RotateCcw,
  Search,
  Settings,
  Settings2,
  ShieldCheck,
  Smartphone,
  Smile,
  Sparkles,
  SquarePen,
  StickyNote,
  Tablet,
  TabletSmartphone,
  Tag,
  ThumbsDown,
  ThumbsUp,
  Ticket,
  Trash2,
  TriangleAlert,
  Upload,
  User,
  Users,
  Utensils,
  Volume1,
  Volume2,
  VolumeX,
  Wallet,
  Moon,
  Sun,
  Wifi,
  Wrench,
  X
};

export const ICON_DEFAULT_SIZE = 16;
export const ICON_DEFAULT_STROKE_WIDTH = 2;

export const MODULE_ICONS: Record<string, string> = {
  commercial: 'briefcase',
  operational: 'network',
  administrative: 'wrench',
  financial: 'dollar-sign',
  ticketOffice: 'ticket',
  inventory: 'notebook-pen'
};
